import React from 'react';
import { Collapse } from '@fiverr-private/transition';
import { useIsClient } from '@fiverr-private/hooks';
import { Container } from '@fiverr-private/layout_components';
import { CollapsibleChildProps } from '../types';
import { useCollapsibleContext } from '../CollapsibleContext';

const CollapsibleContent = ({ children, fontSize = 'b_sm', color = 'grey_1200', ...rest }: CollapsibleChildProps) => {
  const { expanded } = useCollapsibleContext();
  const isClient = useIsClient();
  const open = expanded && isClient;

  return (
    <Collapse in={open} animateOpacity={false}>
      <Container fontSize={fontSize} aria-hidden={!open} color={color} {...rest}>
        {children}
      </Container>
    </Collapse>
  );
};

CollapsibleContent.displayName = 'CollapsibleContent';

export default CollapsibleContent;
